import { createSlice } from '@reduxjs/toolkit'
import { httpRequest, isSafeRedirectUrl } from '@calendly/http-tools'
import { createSelector } from 'reselect'

import { setFormErrors } from 'actions/form'
import GoogleAnalytics from 'services/analytics/google'
import FbPixel from 'services/analytics/facebook_pixel'

const slice = createSlice({
  name: 'routing-form-landing',
  initialState: {
    thankYouMessage: null,
    isAutofillValid: false
  },
  reducers: {
    setThankYouMessage: (state, { payload }) => {
      state.thankYouMessage = payload
    },
    setIsAutofillValid: (state, { payload }) => {
      state.isAutofillValid = payload
    },
  }
})

const reducerKey = 'routingFormLanding'

export const reducerObject = { [reducerKey]: slice.reducer }


const {
  actions: { setThankYouMessage, setIsAutofillValid }
} = slice

export const getThankYouMessageFromRoute = (routeId) => async (dispatch) => {
  const [success, response] = await httpRequest({
    url: `/api/booking/routes/${routeId}`,
    method: 'GET'
  })

  if (!success) {
    return
  }

  const { result_type: resultType, result_value: resultValue } = response

  if (resultType === 'thank_you_text') {
    dispatch(setThankYouMessage(JSON.parse(resultValue)))
    return
  }

  dispatch(setThankYouMessage({ headline: 'Thank you for your submission.' }))
}

const trackFormSubmitted = (formName) => {
  GoogleAnalytics.userTrackEvent('invitee_submits_routing_form', formName)
  FbPixel.trackCustom('invitee_submits_routing_form', formName)
}

export const validateAutofill = (validate) => async (dispatch) => {
  const isValid = await validate()
  dispatch(setIsAutofillValid(isValid))
}

export const createSubmission = ({ formId, formName, submission, params }) => async (dispatch) => {
  const [success, response] = await httpRequest({
    url: `/api/form_builder/forms/${formId}/submissions`,
    method: 'POST',
    data: {
      ...submission,
      url_params: params
    }
  })

  if (!success) {
    dispatch(setFormErrors(response))
    return
  }

  trackFormSubmitted(formName)

  const { result_type: resultType, result_value: resultValue, result_url: resultUrl } = response

  if (resultType === 'arbitrary_url') {
    if (!isSafeRedirectUrl(resultUrl)) return
    window.top.location.href = resultUrl
    return
  }

  if (resultType === 'event_type_id' && resultUrl) {
    window.location.href = resultUrl
    return
  }

  if (resultType === 'thank_you_text') {
    dispatch(setThankYouMessage(JSON.parse(resultValue)))
    return
  }

  dispatch(setThankYouMessage({ headline: 'Thank you for your submission.' }))
}


const rootSelector = (state) => state[reducerKey]

export const thankYouMessageSelector = createSelector(
  rootSelector,
  ({ thankYouMessage }) => thankYouMessage
)

export const isAutofillValidSelector = createSelector(
  rootSelector,
  ({ isAutofillValid }) => isAutofillValid
)
